module.exports = fox._r("images/about-txt.jpg", __webpack_public_path__ + "images/about-txt.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/about-txt.jpg
// module id = 967
// module chunks = 4